// Run `fn` when the person comes back to the AuditPM tab. Browsers fire BOTH "visibilitychange" and "focus" for one
// return, which made pages download everything twice — this runs it once (ignores repeats within 2 s).
// Returns the cleanup function for useEffect.
export function onTabReturn(fn) {
  let last = 0
  const handler = () => {
    if (document.visibilityState !== 'visible') return
    const now = Date.now()
    if (now - last < 2000) return
    last = now
    fn()
  }
  document.addEventListener('visibilitychange', handler)
  window.addEventListener('focus', handler)
  return () => { document.removeEventListener('visibilitychange', handler); window.removeEventListener('focus', handler) }
}
